export default `この度、当社でクラウド目安箱サービスを導入することとなり、その管理者として招待しております。

下記のログインというボタンをクリックした後、メールアドレスとパスワードを入力してログインをお願いします。
ログイン後、基本情報を登録していただくことで、ご利用可能になります。
`;
